module.exports = __webpack_public_path__ + "img/confetti.f03dbbae.svg";